import DataInFormTool from '@/components/learing-registry/data-in-form-tool/data-in-form-tool';
import { learningRegistryAPI } from '@/providers/apis/learning-registry/learning-registry';
import { PERMISSION_CHECK } from '@/utils/constants';
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'create-tool',
    components: {
        'add-new-tool': () => import('@/components/learing-registry/create-registry-form/create-registry-form.vue'),
        'tool-date-in': DataInFormTool,
    },
})

export default class EditTool extends Vue {


    // -----------------------------------------------------------------------
    // Properties

    @Prop()
    private toolPartners: any;

    @Prop({default: {}})
    private activeToolData: any;

    private get toolProviders() {
        return this.activeToolData && this.activeToolData.providerDetails || {};
    }

    private isShowEditTool: boolean = true;

    private permissonCheck = PERMISSION_CHECK;

    private isLoading: boolean = false;

    // ------------------------------------------------------------------------
    // Hooks

    private created() {
        this.checkEditTool();
    }

    // --------------------------------------------------------------------
    // Actions

    private onGoBack() {
        this.$router.push('/partner-catalog/tool-registry');
    }

    private onUpdateTool(toolData: any) {
        this.isLoading = true;
        if (this.$access.isHavingPermisson(this.permissonCheck.createTool)) {
            learningRegistryAPI.updateToolsToProvider(toolData, toolData.id).then(() => {
                this.isLoading = false;
                this.$router.push('/partner-catalog/tool-registry');
            });
        } else {
            this.onConfigTool(toolData);
        }
     }

     private onConfigTool(tool: any) {
        learningRegistryAPI.configureToolInfo(tool).then(() => {
            this.isLoading = false;
            this.$router.push('/partner-catalog/tool-registry');
        });
    }

     private onToggleTab() {
         this.isShowEditTool = !this.isShowEditTool;
     }

    // -----------------------------------------------------------------------
    // Methods

    private checkEditTool() {
        const activeToolData = this.activeToolData;
        if (!this.activeToolData) {
            this.$router.push('/partner-catalog/tool-registry');
        }
    }


}
